import FroalaEditor from 'froala-editor';

export class FroalaEditorHelpers {

  static applyScreenSizeHelper(): void {
    const originalHelpers = FroalaEditor.MODULES.helpers;

    FroalaEditor.MODULES.helpers = function() {
      const helpers = originalHelpers.apply(this, arguments);

      helpers.screenSize = function() {
        if (window.innerWidth >= 840) {
          return FroalaEditor.LG;
        }

        if (window.innerWidth >= 640) {
          return FroalaEditor.MD;
        }

        if (window.innerWidth >= 480) {
          return FroalaEditor.SM;
        }

        return FroalaEditor.XS;
      };

      return helpers;
    };
  }

}
